// export let baseUrl = ""
const baseUrl = process.env.NODE_ENV === "development" ? "dev-api" : process.env.VUE_APP_BASE_URL
// 统一发起请求方法
import {myUploadRequest} from "./common.js"
import uniRequest from "./request.js"

// 上传图片
export function uploadImgByAccessory(filePath, data, count) {
  return myUploadRequest(`${baseUrl}/upload/uploadImgByWebAccessory.htm`, filePath, data, count)
}
// 密码登录
export function getLogin(params) {
  return uniRequest({
    url: '-app-login-user.htm',
    method: 'get',
    params
  })
}
// 注册
export function getRegist(params) {
  return uniRequest({
    url: '/-app-regist-user.htm',
    method: 'get',
    params
  })
}
//获取注册短信验证码
export function getMyCode(params) {
  return uniRequest({
    // url: '/sms/verifyCode.htm',
    url: '/-sms/verify-code.htm',
    method: 'post',
    params
  })
}
// 获取注册短信验证码
export function loginCode(params) {
  return uniRequest({
    // url: '/sms/verifyCode.htm',
    url: '/loginCode.htm' + `?mobile=${params.mobile}&type=${params.type}`,
    method: 'post',
    // params
  })
}
//app-用户密码-重置
export function resetPassword(params) {
  return uniRequest({
    url: '/-app-reset-user.htm',
    method: 'get',
    params
  })
}
//	订单-详情-查询
export function getOrderDetails(params) {
  return uniRequest({
    url: '/user/-eshop/order-detail.htm',
    method: 'get',
    params
  })
}

//店铺订单-订单取消
export function orderCancel(params, type) {
  return uniRequest({
    url: '/user/-eshop/order-cancel.htm',
    method: type,
    params
  })
}

// 删除订单

export function orderDelete(params, type) {
  return uniRequest({
    url: '/user/-eshop/order-delete.htm',
    method: type,
    params
  })
}

//	售后step1-申请售后
export function aftersaleApply(params, type) {
  return uniRequest({
    url: '/user/-af-aftersale-apply.htm',
    method: type,
    params
  })
}
//	地址管理
export function getSeeAddress(params, type) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: type,
    params
  })
}
//	用户添加收货地址
export function getAddAddress(params, type) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: type,
    params
  })
}
//	提交订单[购物车]
export function ordersCart(params, type) {
  return uniRequest({
    url: '/user/-eshop/submit-order.htm',
    method: type,
    params
  })
}
//	店铺订单-前台-查询
export function orderStore(params, type) {
  return uniRequest({
    url: '/user/-eshop-order-main.htm',
    method: type,
    params
  })
}
//	订单-前端-查询
export function orderDetail(params, type) {
  return uniRequest({
    url: '/user/-eshop-order-main.htm',
    method: type,
    params
  })
}
//	售后
export function aftersale(params, type) {
  return uniRequest({
    url: '/user/-aftersale.htm',
    method: type,
    params
  })
}
//	支付流水查询
export function apiPayFlow(params, type) {
  return uniRequest({
    url: '/-api-pay-flow.htm',
    method: type,
    params
  })
}
//	app订单获支付签名
export function unifiedorder(params, type) {
  return uniRequest({
    url: '/user/-od/ali-order-unifiedorder.htm',
    method: type,
    params
  })
}
//读取购物车
export function goodsCart(params, type) {
  return uniRequest({
    url: '/user/-eshop/goods-cart.htm',
    method: type,
    params
  })
}
//产品分类查询
export function getCategory(params) {
  return uniRequest({
    url: '/-a-category.htm',
    method: 'get',
    params
  })
}
//商品查询
export function getGoods(params) {
  return uniRequest({
    url: '/-goods.htm',
    method: 'get',
    params
  })
}
// 文章列表
export function getArticle(params) {
  return uniRequest({
    url: '/-articles.htm',
    method: 'get',
    params
  })
}
// 首页轮播图
export function getSlide(params) {
  return uniRequest({
    url: '/-slideshow.htm',
    method: 'get',
    params
  })
}
// 首页新品推荐
export function getRecommend(params) {
  return uniRequest({
    url: '/-homepage/recommend.htm',
    method: 'get',
    params
  })
}
//判断用户是否收藏
export function getCollection(params) {
  return uniRequest({
    url: '/user/-eshop/collect.htm',
    method: 'get',
    params
  })
}
//用户收藏/取消收藏商品
export function goodsCollection(params) {
  return uniRequest({
    url: '/user/-eshop/collect.htm',
    method: 'post',
    params
  })
}
//商品加入购物车&修改商品数量
export function addCart(params) {
  return uniRequest({
    url: '/user/-eshop/goods-cart.htm',
    method: 'post',
    params
  })
}
//	用户修改收货地址
export function myAddressChange(params) {
  return uniRequest({
    url: '/user/-my-address-change.htm',
    method: 'put',
    params
  })
}
//	通过商品名称搜索商品
export function goodsSearch(params) {
  return uniRequest({
    url: '/-gd-goods-name.htm',
    method: 'get',
    params
  })
}
//	订单搜索
export function sorderSearch(params) {
  return uniRequest({
    url: '/user/-search/sorder-search.htm',
    method: 'get',
    params
  })
}
//	获取3d模型
export function checkThreedModel(params) {
  return uniRequest({
    url: '/-check-threed-model.htm',
    method: 'get',
    params
  })
}

// 获取产品分类
export function getCategories(params) {
  return uniRequest({
    url: '/-eshop/categories.htm',
    method: 'get',
    params
  })
}

// 获取产品列表
export function getgoodsList(params) {
  return uniRequest({
    url: '/-eshop/goods.htm',
    method: 'post',
    params
  })
}

// 顶部搜索
export function searchGoodsList(params) {
  return uniRequest({
    url: '/-home-search.htm',
    method: 'get',
    params
  })
}
export function getCategorList(params) {
  return uniRequest({
    url: '/-eshop/recommended-details.htm',
    method: 'get',
    params
  })
}

// 获取3D模型
export function getThreedModel(params) {
  return uniRequest({
    url: '/-eshop/commodity-model.htm',
    method: 'get',
    params
  })
}

// 获取商品详情
export function getGoodsDetail(params) {
  return uniRequest({
    url: '/-eshop/goods-detail.htm',
    method: 'get',
    params
  })
}
// 底部公告和咨询
export function getMessageList(params) {
  return uniRequest({
    url: '/-res-message-list.htm',
    method: 'get',
    params
  })
}

// 获取新闻咨询的详情
export function getMessageDetails(params) {
  return uniRequest({
    url: '/-res-message-details.htm',
    method: 'get',
    params
  })
}


// 底部公告和咨询分页
export function getMessageListMore(params) {
  return uniRequest({
    url: '/-res-message-more.htm',
    method: 'get',
    params
  })
}
// 首页商品推荐
export function getRecommendList(params) {
  return uniRequest({
    url: '/-eshop/recommended-list.htm',
    method: 'get',
    params
  })
}
// 根据id查询商品分类
export function getCategoryFilterList(params) {
  return uniRequest({
    url: '/-eshop/category-list.htm',
    method: 'get',
    params
  })
}
// 查询商品规格
export function getGoodsSpecification(params) {
  return uniRequest({
    url: '/-eshop/goods-specification.htm',
    method: 'post',
    params
  })
}
// 获取商品对应型号
export function getGoodsModel(params) {
  return uniRequest({
    url: '/-eshop/goods-model.htm',
    method: 'get',
    params
  })
}
// 新增报价
export function addOrderInquiry(params) {
  return uniRequest({
    url: '/user/-add-order-inquiry.htm',
    method: 'post',
    params
  })
}
// 询价列表
export function getOrderInquiry(params) {
  return uniRequest({
    url: '/user/-get-order-inquiry-by-user.htm',
    method: 'get',
    params
  })
}
// 生成线下支付订单
export function getOrderPay(params) {
  return uniRequest({
    url: '/user/-eshop/order-pay.htm',
    method: 'post',
    params
  })
}

// 提交线下支付材料
export function setOfflinePay(params) {
  return uniRequest({
    url: '/user/-eshop/post-order-info.htm',
    method: 'post',
    params
  })
}

// 登出
export function logout(params) {
  return uniRequest({
    url: '/user/-app/logout.htm',
    method: 'post',
    params
  })
}
// 新增投诉
export function addMessage(params) {
  return uniRequest({
    url: '/user/-add-message.htm',
    method: 'post',
    params
  })
}
// 获取投诉列表
export function getMessage(params) {
  return uniRequest({
    url: '/user/-message-list.htm',
    method: 'get',
    params
  })
}
// 获取投诉类型
export function getDictionary(params) {
  return uniRequest({
    url: '/user/-dictionary-query.htm',
    method: 'post',
    params
  })
}
// 立即购买
export function submitOrder(params) {
  return uniRequest({
    url: '/user/-eshop/user-submit-eshop-order.htm',
    method: 'post',
    params
  })
}
export function whetherUser(params) {
  return uniRequest({
    url: '/-whether-user.htm',
    method: 'post',
    params
  })
}
export function updateUserInfo(params) {
  return uniRequest({
    // url: '/user/-applet/xwjy/czly/update-user-phone.htm',
    url: '/user/-update-user.htm',
    method: 'get',
    params
  })
}
export function updatePassword(params) {
  return uniRequest({
    url: '/user/-user-update-password.htm',
    method: 'put',
    params
  })
}
export function uploadAccessory(params) {
  return uniRequest({
    url: '/upload/nologin/uploadAccessory.htm',
    method: 'post',
    params
  })
}
export function getwebsites(params) {
  return uniRequest({
    url: '/-website-info.htm',
    method: 'get',
    params
  })
}
export function getPdfToImages(params) {
  return uniRequest({
    url: '/img/pdfToImages.htm',
    method: 'get',
    params
  })
}
export function getRelation(params) {
  return uniRequest({
    url: '/-eshop/relation-show.htm',
    method: 'get',
    params
  })
}
export function getCharacter(params) {
  return uniRequest({
    url: '/-reception-res-character.htm',
    method: 'get',
    params
  })
}
export function getGoodsCategorys(params) {
  return uniRequest({
    url: '/-goods-cate.htm',
    method: 'get',
    params
  })
}

export function getUserAddressInfo(params) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: 'get',
    params
  })
}
export function postUserAddressInfo(params) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: 'post',
    params
  })
}
export function putUserAddressInfo(params) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: 'put',
    params
  })
}
export function delUserAddressInfo(params) {
  return uniRequest({
    url: '/user/-address-info.htm',
    method: 'delete',
    params
  })
}

// 下载记录
export function downloadRecord(params) {
  return uniRequest({
    url: '/-eshop/file-download.htm',
    method: 'get',
    params
  })
}

// 获取百万规格选型页面token
export function xindiSelectionToken(params) {
  return uniRequest({
    url: '/-xindi/selection-token.htm',
    method: 'get',
    params
  })
}
// 根据ndc数据写入规格实例
export function postSpecInstByNdc(params) {
  return uniRequest({
    url: '/user/-eshop/spec-inst-by-ndc.htm',
    method: 'post',
    params
  })
}
// 获取设备唯一码
export function getDeviceId(params) {
  return uniRequest({
    url: '/device-id.htm',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/common/http.js